import React from 'react';
import { CheckCircle2, ShieldCheck, Award, HeartHandshake } from 'lucide-react';
export function TrustBar() {
  return <div className="bg-brand-lightMint border-b border-teal-100 py-3 px-4" data-id="element-165">
      <div className="max-w-6xl mx-auto" data-id="element-166">
        {/* Mobile view: scrolling or stacked text, but for simplicity we'll show a concise version or wrap */}
        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-xs sm:text-sm font-medium text-teal-800" data-id="element-167">
          <div className="flex items-center gap-1.5" data-id="element-168">
            <HeartHandshake className="w-4 h-4 text-brand-mint" data-id="element-169" />
            <span data-id="element-170">15.728+ tevreden klanten</span>
          </div>
          <div className="hidden sm:block text-teal-300" data-id="element-171">•</div>
          <div className="flex items-center gap-1.5" data-id="element-172">
            <ShieldCheck className="w-4 h-4 text-brand-mint" data-id="element-173" />
            <span data-id="element-174">Zonder straffen of corrigeren</span>
          </div>
          <div className="hidden md:block text-teal-300" data-id="element-175">•</div>
          <div className="flex items-center gap-1.5 hidden md:flex" data-id="element-176">
            <Award className="w-4 h-4 text-brand-mint" data-id="element-177" />
            <span data-id="element-178">Wetenschappelijke methodes</span>
          </div>
          <div className="hidden lg:block text-teal-300" data-id="element-179">•</div>
          <div className="flex items-center gap-1.5 hidden lg:flex" data-id="element-180">
            <CheckCircle2 className="w-4 h-4 text-brand-mint" data-id="element-181" />
            <span data-id="element-182">Dierenwelzijn keurmerk</span>
          </div>
        </div>
      </div>
    </div>;
}